function App() {
  return <h1>Witaj, świecie!</h1>;
}

export default App;
